import React from 'react'
import { Panel, Box } from 'rsuite'

import * as styles from './Container.m.css'

type Props = {
  children: React.ReactNode | React.ReactNode[]
}

const Container: React.FC<Props> = ({ children }): React.ReactElement => {
  return (
    <Panel bordered>
      <Box className={styles.content}>{children}</Box>
    </Panel>
  )
}

export default Container
